import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { SplitFactory } from '@splitsoftware/splitio'

import { SPLIT_ID } from 'constants/ResourcesConstants'
import * as UserActions from 'app/modules/user/actions'
import * as actions from './actions'
import { UserFeature, AccountFeature } from './constants'

export let client

const receiveCurrentUser = (action$, store) => {
  return action$
    .ofType(UserActions.receiveCurrentUser.toString())
    .pluck('payload')
    .first(({ id, orgId }) => {
      const logImpression = ({ impression: { feature, treatment } }) => {
        analytics.track('Experiment Viewed', {
          experimentName: feature,
          variationName: treatment,
          source: 'split',
        })
      }

      const factory = SplitFactory({
        core: {
          authorizationKey: SPLIT_ID,
          key: orgId,
          trafficType: 'organization'
        },
        impressionListener: {
          logImpression,
        },
      })

      client = factory.client()
      client.on(client.Event.SDK_READY, () => {
        store.dispatch(actions.setLoaded())
      })
      client.on(client.Event.SDK_READY_TIMED_OUT, () => {
        store.dispatch(actions.timedOut())
      })
    })
}

export const epic = combineEpics(receiveCurrentUser)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/experiment/epic.js